import { Fragment, memo, PureComponent } from 'react';
import { Formik, Field, FormikProps, FormikActions } from 'formik';
import Select from 'components/Select';
import messages from './Messages';
import { IOption } from 'components/Select/Select';
import { RoleSelector, SaveButton } from './styles';
import { ICompanyRole } from 'store/companies/companiesTypes';

interface ComponentProps {
  companyId: number;
  fastAccess: string[];
  onSubmitFastAccess: (fastAccess: string[]) => void;
  companyRoles: { [key: number]: ICompanyRole };
  companyRolesOptions?: IOption[];
}

interface IFormValues {
  selectedRoles: IOption[];
}

class RoleLimitation extends PureComponent<ComponentProps> {
  handleSubmitForm = async (
    values: IFormValues,
    formikAction: FormikActions<IFormValues>
  ) => {
    const tagRoles = values.selectedRoles.map((role) => `role$$${role.value}`);
    await this.props.onSubmitFastAccess(tagRoles);
    formikAction.setSubmitting(false);
  };

  render() {
    const { fastAccess, companyRolesOptions, companyRoles } = this.props;
    const initialValues: IFormValues = {
      selectedRoles:
        fastAccess.length > 0
          ? fastAccess.reduce((tmp: IOption[], fastAccessRole: string) => {
              const roleId = Number(fastAccessRole.split('$$')[1]);
              if (roleId) {
                const selectedRole = Object.values(companyRoles).find(
                  (role: ICompanyRole) => role.id === roleId
                );
                if (selectedRole) {
                  tmp.push({
                    value: selectedRole.id,
                    label: selectedRole.name,
                  });
                }
              }
              return tmp;
            }, [])
          : [],
    };
    return companyRolesOptions ? (
      <Fragment>
        <span>{messages.rolesAccess}</span>
        <Formik
          onSubmit={this.handleSubmitForm}
          initialValues={initialValues}
          validateOnBlur={false}
          validateOnChange={false}
        >
          {(formikBag: FormikProps<IFormValues>) => (
            <RoleSelector>
              <Field name="selectedRoles">
                {() => (
                  <Select
                    multiChoice={true}
                    options={companyRolesOptions}
                    values={formikBag.values.selectedRoles}
                    onChangeValues={(roles) => {
                      formikBag.setFieldValue('selectedRoles', roles);
                    }}
                    placeholder={messages.addRole}
                  />
                )}
              </Field>
              <SaveButton
                type="submit"
                color="green"
                loading={formikBag.isSubmitting}
              >
                {messages.save}
              </SaveButton>
            </RoleSelector>
          )}
        </Formik>
      </Fragment>
    ) : (
      <p>{messages.noRoles}</p>
    );
  }
}

export default memo(RoleLimitation);
